import { keyMap } from "./constants"

export const state = {
  numPlayers: 0,
  numDirects: 0,
  numRounds: 0,
  fileName: "",
  gameStartTime: null,
  gameId: "",
  objectId: null,
  gameType: "mimir", //"stakes"
  players: [ //Array of all the players in the game
    // {
    //   name: "",
    //   id: 0,
    //   placeholder: "Player 1 Name",
    //   emptySeat: false,
    // },
  ],
  readerName: "",
  currentQuestionNo: 0, //The number of the current question from the set
  totalQuestions: 0,
  currentCount: 0, //The number of passes on the current question
  current: {
    //Object with the current status respect to round/player/direct
    round: 1,
    player: 0,
    question: 1,
  },
  scoreTable: {
    // scores: [100, 100, 100, 100],
    // owns: [[0, 0], [0, 0], [0, 0], [0, 0]], //[own answered correctly, owns in total]
    // bonusAttempts: [0, 0, 0, 0],
    // notAnswered: [0, 0, 0, 0],
    // totalCorrect: [0, 0, 0, 0],
    // stake5: [[0, 0], [0, 0], [0, 0], [0, 0]], //each element stores [staked correctly, staked in total]
    // stake10: [[0, 0], [0, 0], [0, 0], [0, 0]],
    // stake20: [[0, 0], [0, 0], [0, 0], [0, 0]],
    // bonusPoints: [0, 0, 0, 0],
    // roundSummary: [[0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0]],
    // previousSummary: [[0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0]]
  },
  onDirect: true, //are we currently on a direct or a pass
  passingSequence: [0, 1, 2, 3],
  timer: {
    //Timer attributes
    timer: null,
    directTime: 30,
    passTime: 5,
    displayTime: 30,
    adjustTime: 5,
    passOnEmptyTime: 10,
    INTERVAL: 1000,
    autoPass: null, //contains the setInterval object to pass automatically after X sec on empty direct
  },
  questionsList: [],
  questionDisplayMode: "Start", //["Start", "ShowAnswer", "Question", "Answer"]
  finishGame: false,
  gamePlayHistory: [],
  gamePlayString: "", //C-Correct, P-Pass, W-Wrong, RTY-Stake 1,10,15 C, FGH- Stake 5,10,15 W, K-Kill
  keyMap,
  listOfPlayerNames: [
  ],
  b612Friendly: false,
  resumeGame: false,
  instructions: [],
  gameNotes: "",
  currentActionSequence: "",
  selfReadSwitch: false,
  peekAnswer: false,
  leagueName: "",
  leagueSeason: "",
  gameWeek: "",
  matchNumber: "",
  leagueMatch: false,
  gamePlayPointer: 0,
  buttonContainerCompactFlag: false,
  log: "This is a text string. Lorem Ipsum domenum tecum.",
  freeDirect: true,
};
